<template>
    <Dropdown :class="[ size ? 'p-inputtext-' + size : '' ]" v-model="text" :options="datas" :optionLabel="caption_name" :optionValue="value_name" :placeholder="placeholder" :scrollHeight="scrollHeight"
    :editable="editable" :showClear="showClear" :loading="loading" :disabled="readonly" :filter="filter" style="line-height: initial;width: 14rem;" />
</template>

<script>
import { computed } from 'vue'
import Dropdown from 'primevue/dropdown';

export default {
    name: 'tw-dropdown',
    components: {
        Dropdown
    },
    setup(props, context) {
        const datas = computed(() => {
            return (props.data_source && props.data_source.datas) || []
        })

        const text = computed({
            get() {
                return (props.modelValue === null || props.modelValue === undefined) ? null : props.modelValue
            },
            set(value){
                context.emit('update:modelValue', value)
            }
        })

        return {
            text,
            datas
            // columns,
            // showSummary
        }
    },
    props: {
        data_source: {
            type: Object,
            default: function() {
                return { }
            }
        },
        caption_name: {
            type: String,
            default: 'label'
        },
        value_name: {
            type: String,
            default: 'value'
        },
        modelValue: null,
        size: String,
        readonly: Boolean,
        placeholder: String,
        scrollHeight: String,
        editable: Boolean,
        showClear: {
            type: Boolean,
            default: true
        },
        loading: Boolean,
        filter: Boolean
    }
}
</script>
<style lang="scss" scoped>
.country-item {
    img {
        width: 17px;
        margin-right: 0.5rem;
    }
}
</style>